




























import Vue from 'vue';
import { objectValues, GetRelationExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';
import { ListOptions } from '../../../common';


export default ExpressionBase<GetRelationExpression>().extend({
  name: 'GetRelationEditor',
  computed: {
    relations(): ListOptions<string> {
      return this.registry.defs.relations.keys.map((relation) => ({
        text: relation,
        value: relation,
      }));
    },
  },
});
